import { useSelector } from "react-redux";

const useGuides = () => {
    const guides = useSelector((state) => state.guides);
    return guides;
};

export default useGuides;